import { useDispatch } from "react-redux";
import classes from "./CookieElement.module.css";
import { setIsCookieModalShown } from "../../redux/globalFunctions";

export function CookieElement() {
  const dispatch = useDispatch();

  return (
    <div
      className={classes.imgContainer}
      onClick={() => dispatch(setIsCookieModalShown(true))}
    >
      <svg
        style={{ fill: "#fff" }}
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        fill="#FFF"
      >
        <path
          fillRule="evenodd"
          d="M7.328.07c.463 0 .917.043 1.356.125.21.04.3.289.228.49a1.5 1.5 0 001.27 1.99h.001a.22.22 0 01.213.243 3.218 3.218 0 003.837 3.453c.18-.035.365.078.384.26A7.328 7.328 0 117.329.07zm.263 10.054a1.427 1.427 0 100 2.854 1.427 1.427 0 000-2.854zM3.697 7.792a.884.884 0 100 1.769.884.884 0 000-1.769zm5.476-.488a.884.884 0 100 1.768.884.884 0 000-1.768zM5.806 3.628a1.427 1.427 0 100 2.854 1.427 1.427 0 000-2.854z"
        ></path>
      </svg>
      <span>Cookies</span>
    </div>
  );
}
